import * as React from 'react';
import './employee-list-modal.scss';
import { ReactComponent as Close } from '../../../assets/images/close.svg';
import Button from '../../../common/button/button';
import { IInvitedEmpWithRegist } from 'types/employee-registration';

interface Props {
  headerText: string;
  subHeaderText: string;
  tableHeads: string[];
  tableData: IInvitedEmpWithRegist[];
  showCompleteBtn: boolean;
  onAction: () => void;
}

const EmployeeListModal: React.FC<Props> = ({
  headerText,
  subHeaderText,
  tableHeads,
  tableData,
  showCompleteBtn,
  onAction,
}) => {
  return (
    <div className="employee-list-modal-background">
      <div className="employee-list-modal">
        <div className="employee-list-modal__modal-header">
          {headerText} <span className="employee-list-modal__head-span">{tableData.length}</span>
        </div>
        <div className="employee-list-modal__modal-subheader">{subHeaderText}</div>
        <div className="employee-list-modal__modal-body">
          <table className="employee-list-modal__modal-table">
            <colgroup>
              <col width={'50%'} />
              <col width={'50%'} />
            </colgroup>
            <tr className="employee-list-modal__modal-tr">
              {tableHeads &&
                tableHeads.map((head) => (
                  <th className="employee-list-modal__modal-tr__head" key={head}>
                    {head}
                  </th>
                ))}
            </tr>
            {tableData.length > 0 &&
              tableData.map((i) => (
                <tr className="employee-list-modal__modal-tr__content" key={i.empSeq}>
                  <td className="employee-list-modal__modal-td">
                    <div className="employee-list-modal__modal-td__name">{i.empName}</div>
                  </td>
                  <td className="employee-list-modal__modal-td">
                    <div>{i.empPhone}</div>
                  </td>
                </tr>
              ))}
          </table>
        </div>
        {showCompleteBtn && (
          <div className="employee-list-modal__button">
            <Button label={'합류완료'} type={'type2'} action={onAction} />
          </div>
        )}
      </div>
    </div>
  );
};
export default EmployeeListModal;
